import { Button } from "./ui/button";
import { Home, Bot, Users, Phone, BookOpen, ShoppingCart, Sparkles } from "lucide-react";
import { NavLink } from "./NavLink";
import neilLogo from "@/assets/neil-ai-logo-main.jpg";

const Navigation = () => {
  const navLinks = [
    { to: "/", icon: Home, label: "Home" },
    { to: "/robots", icon: Bot, label: "Robots" },
    { to: "/ai-automation", icon: Sparkles, label: "AI Automation" },
    { to: "/case-studies", icon: Users, label: "Case Studies" },
    { to: "/accessories", icon: ShoppingCart, label: "Accessories" },
    { to: "/blog", icon: BookOpen, label: "Blog" },
    { to: "/about", icon: Users, label: "About" },
    { to: "tel:3369624539", icon: Phone, label: "Contact" },
  ];

  return (
    <nav 
      className="fixed top-0 left-0 right-0 z-50 glass-strong border-b border-neon backdrop-blur-xl"
      style={{
        boxShadow: "0 8px 32px hsl(var(--primary) / 0.2)",
      }}
    >
      <div className="max-w-7xl mx-auto px-4 py-3">
        <div className="flex items-center justify-between gap-4 flex-wrap">
          {/* Company Name */}
          <div className="flex items-center gap-2">
            <h1 className="text-base sm:text-lg md:text-xl font-bold bg-gradient-to-r from-primary via-accent to-secondary bg-clip-text text-transparent hover:scale-105 transition-transform duration-300 leading-tight">
              NEIL AI GLOBAL SOLUTIONS LLC
            </h1>
          </div>

          {/* Quick Links */}
          <div className="flex items-center gap-2 flex-wrap">
            {navLinks.map((link) => {
              const Icon = link.icon;
              return (
                <NavLink
                  key={link.to}
                  to={link.to}
                  className="flex items-center gap-2 px-3 py-2 rounded-lg glass-effect hover:glass-strong transition-all duration-300 text-sm font-medium touch-manipulation"
                  activeClassName="border-neon glow-cyan"
                >
                  <Icon className="h-4 w-4" />
                  <span className="hidden md:inline">{link.label}</span>
                </NavLink>
              );
            })}
          </div>

          {/* CTA Button */}
          <Button
            asChild
            size="sm"
            variant="secondary"
            className="font-bold glow-gold touch-manipulation"
          >
            <a href="https://api.leadconnectorhq.com/widget/bookings/neilaipudurobotics" target="_blank" rel="noopener noreferrer">
              Book Demo
            </a>
          </Button>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
